import Cookies from "js-cookie";

const cookies = Cookies.get();

const template = document.createElement("template");
template.innerHTML = `
    <style>
        .cookie-container{
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: #333;
            color: white;
            padding: 1rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            z-index: 9999;
            transition: all .2s ease-in-out;
        }
        
        .cookie-container a{
            text-decoration: none;
            color: #4CAF50;
        }
        
        .cookie-container h3{
            margin: 0;
        }
        
        .cookie-container a:hover{
            cursor: pointer;
        }
        
        .cookieButton{
            background: #fff;
            border: none;
            padding: .5rem 1rem;
            border-radius: 4px;
            cursor: pointer;
            font-weight: bold;
        }
    </style>
    <div class="cookie-container">
        <h3>Cookie Consent</h3>
        <div>
            <p>This website uses cookies to ensure you get the best experience on our website. 
            Please read our <span><a href="./privacy.html">privacy policy</a></span> for more information about how we use cookies.</p>
            <button id="cookie-accept" class="cookieButton">Ok</button>
            <button id="cookie-reject-other" class="cookieButton">Reject Non-essential</button>
        </div>
    </div>
`;

class CookieBanner extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        console.log("element is working")

        const shadowRoot = this.attachShadow({mode: "closed"})
        let clone = template.content.cloneNode(true);
        shadowRoot.append(clone);

        shadowRoot.querySelector("#cookie-accept").addEventListener("click", () => {
            console.log("Consent granted")
            this.style.display = "none";
            Cookies.set("cookieConsent", "true", {sameSite: "strict"});
            window.dataLayer = window.dataLayer || [];

            function gtag() {
                dataLayer.push(arguments);
            }

            gtag('js', new Date());

            gtag('config', 'G-138E1FRVRR');
        })

        shadowRoot.querySelector("#cookie-reject-other").addEventListener("click", () => {
            console.log("Other Consent rejected")
            this.style.display = "none";
            Cookies.set("cookieConsent", "true", {sameSite: "strict"});
            Cookies.set("XConsent", "false", {sameSite: "strict"});
        })
    }
}

if (!customElements.get("cookie-banner") && !cookies.cookieConsent) {
    customElements.define("cookie-banner", CookieBanner);
}